<ng-container *ngIf="!inGroepen">
  <ul class="ols-checkbox-group" [ngClass]="{'not-active': !isCurrentVraag, 'ols-col-2': vraag.antwoorden.length > 8}">
    <li class="ols-checkbox" *ngFor='let antwoord of vraag.antwoorden' (click)='multiselectClicked(antwoord)'
      [id]="geefMeetidMulti(vraag.titel, antwoord.titel)" [ngClass]="{'selected': antwoordGeselecteerd(antwoord)}">
      <div class='ols-box'>
        <div class='outer'></div>
      </div>
      <div class='text'>
        <div class='text-header'>{{antwoord.titel}}</div>
        <div *ngFor='let regel of antwoord.antwoordregels'>{{regel}}</div>
      </div>
    </li>
  </ul>
</ng-container>
<ul *ngIf="inGroepen" class="ols-checkbox-groepen">
  <li *ngFor="let groep of groepen" class="ols-chckbx">
    <div class="ols-checkbox-group-titel">{{groep.groep_titel}}</div>
    <ul class="ols-checkbox-group" [ngClass]="{'not-active': !isCurrentVraag}">
      <ng-container *ngFor="let antwoord of vraag.antwoorden">
        <li class="ols-checkbox" *ngIf="groep.groep_id === antwoord.groep_id" (click)='multiselectClicked(antwoord)'
          [id]="geefMeetidMulti(vraag.titel, antwoord.titel)" [ngClass]="{'selected': antwoordGeselecteerd(antwoord)}">
          <div class='ols-box'>
            <div class='outer'>
            </div>
          </div>
          <div class="text">
            <div>{{antwoord.titel}}
              <ng-container *ngIf="antwoord.antwoordregels && antwoord.antwoordregels.length > 0">
                (<ng-container *ngFor='let regel of antwoord.antwoordregels'>{{regel}}</ng-container>)
              </ng-container>
            </div>
          </div>
          <ng-container *ngIf="antwoord.icon">
            <div class="ols-icon">
              <app-icon [icon]="antwoord.icon" [iconCssClass]="'ols-connectedvraag-icon'"></app-icon>
            </div>
          </ng-container>
        </li>
      </ng-container>
    </ul>
  </li>
</ul>

<p class="error-block" *ngIf="submitClicked && minChoices > selectedIds.length && minChoices === 1">Maak alsjeblieft een keuze</p>
<p class="error-block" *ngIf="submitClicked && minChoices > selectedIds.length && minChoices > 1">Maak minimaal {{minChoices}} keuzes</p>